/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import ProcessCategoryUpdateDialog from "../dialogTypes/ProcessCategoryUpdateDialog";
import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";

function ProcessCategoryUpdateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSelectGrid, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {
        if(onSelectGrid) {
            setFormData(onSelectGrid);
        }
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <UpdateRecordButtonLayout id={id+"update-button"} onClick={onOpen} {...others} />
            <ProcessCategoryUpdateDialog
                id={id+"update-dialog"}
                mode="edit"
                formId={id+"update-form"}
                title={t(`dialog.title.${schema.name}.update`)}
                schema={schema}
                open={open}
                onClose={onClose}
                initialData={formData}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default ProcessCategoryUpdateButton;

